import { FunctionalComponent, VNode, h } from '@stencil/core';
import { height as faTimesHeight, svgPathData as faTimesSvgPathData, width as faTimesWidth } from '@fortawesome/pro-light-svg-icons/faTimes';
import { generateSVGImage } from 'utils/imageHelper';

/**
 * @hidden
 */
interface IAlertCloseButtonProps {
  label: string;
  clickHandler: (evt: MouseEvent) => void;
}

enum SVGDefaultsFaTimes {
  WIDTH = 384,
  HEIGHT = 512,
  PATH_DATA = 'M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z',
}

/**
 * @return {FunctionalComponent}  The close button
 */
export const AlertCloseButton: FunctionalComponent<IAlertCloseButtonProps> = ({ label, clickHandler }: IAlertCloseButtonProps) => {
  const svgPathDataFaTimes = faTimesSvgPathData ?? SVGDefaultsFaTimes.PATH_DATA;
  const svgHeightFaTimes = faTimesHeight ?? SVGDefaultsFaTimes.HEIGHT;
  const svgWidthFaTimes = faTimesWidth ?? SVGDefaultsFaTimes.WIDTH;

  return (
    <button class={`c-alert__close`} aria-label={label} data-track="true" data-track-value={label} onClick={clickHandler}>
      {generateSVGImage({ data: svgPathDataFaTimes, height: svgHeightFaTimes, width: svgWidthFaTimes })}
    </button>
  ) as VNode;
};
